<h1 mat-dialog-title>ATENCIÓN</h1>
<div mat-dialog-content>
  <p>Seleccionados {{data.numElementos}} inmuebles. ¿Desea continuar?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false" (click)="onCancel()">Cancelar</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</div>
